import { Link } from "react-router-dom";
import { Thermometer, Sun, CloudRainWind, Zap, Cpu, SunMedium, Wind, Droplets, ShieldCheck, Waves, Accessibility, Sparkles, Leaf, Gem, DraftingCompass } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { CONCEPTS } from "@/data/content";

const ICONS = { Thermometer, Sun, CloudRainWind, Zap, Cpu, SunMedium, Wind, Droplets, ShieldCheck, Waves, Accessibility, Sparkles, Leaf, Gem, DraftingCompass };

const slugify = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const Concepts = () => (
    <section id="concepts" data-testid="concepts-section" className="paper-grid relative overflow-hidden py-24 lg:py-36">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
            <SectionHeading
                id="concepts-heading"
                overline="Unique Construction Concepts"
                title={<>Build a home that <span className="text-flame-dark">fits your life.</span></>}
                description="OMSIVO concept homes start from how you live — climate, comfort, safety and the future — before a single wall is drawn. Open any concept to explore it in depth."
            />
            <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
                {CONCEPTS.map((c, i) => {
                    const Icon = ICONS[c.icon];
                    return (
                        <Reveal key={c.title} delay={0.04 * (i % 5)} className="h-full">
                            <Link
                                to={`/concepts/${slugify(c.title)}`}
                                data-testid={`concept-card-${i}`}
                                className="lift-card group flex h-full w-full flex-col rounded-2xl border border-omsivo-navy/10 bg-white p-6 text-left"
                            >
                                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-omsivo-navy/5 text-omsivo-blue transition-all group-hover:bg-flame group-hover:text-white">
                                    <Icon className="h-5 w-5" />
                                </div>
                                <h3 className="mt-5 font-display text-sm font-extrabold uppercase leading-snug tracking-[0.05em] text-omsivo-navy">
                                    {c.title}
                                </h3>
                                <p className="mt-2 text-[13px] leading-relaxed text-slate-600">{c.text}</p>
                                <span className="mt-auto pt-4 font-mono text-[9px] font-semibold uppercase tracking-[0.18em] text-omsivo-blue transition-colors group-hover:text-flame-dark">
                                    Explore concept
                                </span>
                            </Link>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
